(function () {
    "use strict";
    angular
        .module('harriApp')
        .controller("EditGoodFaithEstimateShiftsModalController", EditGoodFaithEstimateShiftsModalController);

    EditGoodFaithEstimateShiftsModalController.$inject = ['$scope', 'positionsDataService', 'onSave', 'onStart', 'onDelete', 'modalData', 'businessDayUtils', 'ShiftTemplateUtils','hUser' ,'$q', 'GoodFaithEstimateScheduleDataService'];

    function EditGoodFaithEstimateShiftsModalController($scope, positionsDataService, onSave, onStart, onDelete, modalData, businessDayUtils, ShiftTemplateUtils, hUser, $q, GoodFaithEstimateScheduleDataService) {
        var self = this;
        self.mode = modalData.mode;
        var shift = modalData.shift;
        var action = modalData.action;
        var day = modalData.day;
        var businessDay = modalData.businessDay;
        var docCode = modalData.docCode;
        var brandId = modalData.brandId;
        var regularScheduleSettings = modalData.regularScheduleSettings;
        self.isLocked = modalData.isLocked;


        if (onStart) {
            onStart();
        }

        var init = function () {
            self.EditGoodFaithEstimateShiftsForm = new EditGoodFaithEstimateShiftsForm($scope, positionsDataService, businessDayUtils, ShiftTemplateUtils ,hUser,$q, GoodFaithEstimateScheduleDataService);
            self.EditGoodFaithEstimateShiftsForm.load(self.mode, shift, day, businessDay, docCode, brandId, regularScheduleSettings);
        };

        self.close = function () {
            $scope.$hide();
        };

        self.delete = function () {
            onDelete && onDelete(shift);
            self.close();
        };

        self.save = function () {
            self.EditGoodFaithEstimateShiftsForm.save()
                .then(function (shift) {
                    onSave(shift, action);
                    self.close();
                })
                .catch(function (err) {

                });
        };

        init();
    }
})();